export default __webpack_public_path__ + "static/media/heiwa.02d744d2.svg";